import React, { useEffect } from 'react';
import { Link } from "react-router-dom";
import { useTranslation } from 'react-i18next';

// material-ui icons
import Check from "@material-ui/icons/Check";
import LoopIcon from '@material-ui/icons/Loop';
import Close from "@material-ui/icons/Close";
import ErrorIcon from '@material-ui/icons/Error';

// material-ui components
import CircularProgress from '@material-ui/core/CircularProgress';
import Slide from "@material-ui/core/Slide";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";

// core components
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import Button from "beaktShared/components/CustomButtons/Button.js";
import Card from "beaktShared/components/Card/Card.js";
import CardBody from "beaktShared/components/Card/CardBody.js";
import HeaderProcessoFinal from "beaktClinic/views/Venda/Header/HeaderProcessoFinal"
import QrCodeBeaktPix from "beaktClinic/views/Venda/Pagamentos/QRCodeBeaktPix";

// Outros components
import SweetAlert from "react-bootstrap-sweetalert";
import QRCode from "react-qr-code";

// services
import { setResultadoVendaCookie, getResultadoVendaCookie } from "beaktClinic/services/carrinhoVenda";
import { UseGetApiSimple, UsePostApi } from "beaktShared/services/crudeApiService";
import ContratoVenda from "beaktClinic/views/Venda/ContratoVenda";
import ContratoVendaCamaCam from "beaktClinic/views/Venda/ContratoVendaCamaCam";
import ContratoVendaDM2 from 'beaktClinic/views/Venda/ContratoVendaDM2';

// style
import { makeStyles } from "@material-ui/core/styles";
import styles from "assets/jss/BeaktClinic/views/Venda/finalizacaoVenda.js";
const useStyles = makeStyles(styles);

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});


export default function FinalizacaoVenda({ history }) {
  const { t } = useTranslation();
  const classes = useStyles();

  const [resultadoVenda, setresultadoVenda] = React.useState({
    status: null, mensagem: "", mensagem_beakt: ""
  });

  useEffect(() => {
    let resultadoVenda = getResultadoVendaCookie();
    if (resultadoVenda != null) {
      setresultadoVenda(resultadoVenda);
      setResultadoVendaCookie(null);
      if (resultadoVenda.qrCodeBeaktPix)
        set_vendaQRCode(resultadoVenda)
    }
    else {
      history.push("/adminclinic/venda");
    }
  }, []);

  const [loadComplete, setloadComplete] = React.useState(false);

  const statusPagamentoVenda = () => {
    setloadComplete(true);
    let endPoint = "vendas/StatusPagamento/" + resultadoVenda.vendaId;
    UsePostApi(endPoint, null).then(result => {
      setloadComplete(false);
      if (result.status !== 200) {
        showAlert(result.message, 'warning');
        return false;
      }

      setresultadoVenda(result.data);
      if (result.data.status === 4)
        set_vendaQRCode(null)
    });
  }

  const [vendaContrato, setvendaContrato] = React.useState(null);
  const [showModalContrato, setshowModalContrato] = React.useState(false);
  const [contratoFranquia, setcontratoFranquia] = React.useState();

  const visualizarContrato = (() => {
    const endPoint = "contratovendas/" + resultadoVenda.vendaId;
    UseGetApiSimple(endPoint, 0).then(result => {
      if (result.status !== 200) {
        showAlert(result.message, 'danger')
        return false;
      }

      setvendaContrato(result.data);
      setcontratoFranquia(result.data.contratoFranquia);

      setshowModalContrato(true);
    });
  });

  const handleComprovantesCartao = () => {
    UseGetApiSimple("vendas/ComprovantesCartao/" + resultadoVenda.vendaId, 0).then(result => {
      if (result.status !== 200) {
        showAlert(result.message, 'danger')
        return false;
      }
      if (result.data != "") {
        var printWin = window.open('', '', 'left=0,top=0,width=720,height=1000,toolbar=0,scrollbars=0,status=0');
        var html = `<html><head></head><body><div style='white-space:break-spaces'>` + result.data + `</div></body></html>`;
        printWin.document.write(html);
        printWin.document.close();
        printWin.focus();
        printWin.print();
        printWin.close();
      }
      else
        showAlert("Nenhum comprovante disponível para impressão!", 'warning')
    });
  }

  const [alert, setalert] = React.useState();
  const showAlert = (message, tipo) => {
    setalert(<SweetAlert
      warning={tipo == 'warning' ? true : false}
      success={tipo == 'success' ? true : false}
      title={t('label.warning')}
      onConfirm={() => setalert(null)}
    >
      <div dangerouslySetInnerHTML={{ __html: message }} />
    </SweetAlert>);
  };

  const [vendaQRCode, set_vendaQRCode] = React.useState(null);

  return (
    <div className="maxContent no-print">
      {loadComplete &&
        <div className="carregandoCmp">
          <div className="box">
            <label>{t('label.loading')}...</label>
            <CircularProgress />
          </div>
        </div>
      }

      {alert}

      <HeaderProcessoFinal etapa={3}></HeaderProcessoFinal>

      <GridContainer>

        <GridItem xs={12} sm={12} md={12}>
          <Card>
            <CardBody>
              <br /><br />
              <center>
                {resultadoVenda.status !== 2 && resultadoVenda.status !== 6 && <Check className={classes.icoBoxEnd}></Check>}
                {resultadoVenda.status === 2 && <LoopIcon className={classes.icoBoxEnd}></LoopIcon>}
                {(resultadoVenda.status === 6 || resultadoVenda.status === 6) && <ErrorIcon color="error" className={classes.icoBoxEnd}></ErrorIcon>}
                <h3>{resultadoVenda.mensagem}</h3>
                <h5>{resultadoVenda.mensagem_beakt}</h5>
                <br />
                <br />
                {resultadoVenda.status === 4 &&
                  <Link to="/adminclinic/venda" >
                    <Button color="primary" >
                      {t('sale.make_new_sale')}
                    </Button>
                  </Link>
                }
                {resultadoVenda.status != 4 &&
                  <Link to="/adminclinic/vemandamento" >
                    <Button color="primary" >
                      {t('sidebar.sales_progress')}
                    </Button>
                  </Link>
                }
                {resultadoVenda.status === 2 &&
                  <Button color="info" onClick={statusPagamentoVenda}>
                    {t('sale.check_payment')}
                  </Button>
                }
                {resultadoVenda.status === 2 && resultadoVenda.qrCodeBeaktPix != null &&
                  <Button color="warning" onClick={() => set_vendaQRCode(resultadoVenda)}>
                    QR Code PIX
                  </Button>
                }
                {(resultadoVenda.temContrato && resultadoVenda.status === 4) &&
                  <Button color="info" onClick={visualizarContrato}>
                    EMITIR CONTRATO
                  </Button>
                }
                {(resultadoVenda.temComprovanteCartao && resultadoVenda.status === 4) &&
                  <Button color="info" onClick={handleComprovantesCartao}>
                    {t('sale.receipt_card')}
                  </Button>
                }
              </center>

            </CardBody>
          </Card>
        </GridItem>
        <Dialog
          classes={{ root: classes.center + " " + classes.modalRoot, paper: classes.modal + ' ' + classes.modalLarge }}
          open={showModalContrato}
          TransitionComponent={Transition}
          keepMounted
          onClose={() => setshowModalContrato(false)}
          aria-labelledby="classic-modal-slide-title"
          aria-describedby="classic-modal-slide-description"
        >
          <DialogTitle
            id="classic-modal-slide-title"
            disableTypography
            className={classes.modalHeader}
            style={{ background: '#5c4477' }}
          >
            <Button
              justIcon
              className={classes.modalCloseButton}
              key="close"
              aria-label="Close"
              color="transparent"
              onClick={() => setshowModalContrato(false)}
            >
              <Close className={classes.modalClose} />
            </Button>
            <h4 className={classes.modalTitle} style={{ color: 'white' }}>{t('sale.contract_sale')}</h4>
          </DialogTitle>
          <DialogContent id="classic-modal-slide-description"
            className={classes.modalBody} style={{ background: '#f0f0f0' }}
          >
            <br />
            {contratoFranquia == 'Emagrecentro' && <ContratoVenda venda={vendaContrato}></ContratoVenda >}
            {contratoFranquia == 'CamaCam' && <ContratoVendaCamaCam venda={vendaContrato}></ContratoVendaCamaCam >}
            {contratoFranquia == 'DM2' && <ContratoVendaDM2 venda={vendaContrato}></ContratoVendaDM2 >}

          </DialogContent>
        </Dialog>
      </GridContainer>

      {vendaQRCode &&
        <QrCodeBeaktPix qrCodeBeaktPix_value={vendaQRCode.qrCodeBeaktPix} showModal={true} closeModal={() => set_vendaQRCode(null)} atualizarStatus={() => statusPagamentoVenda(vendaQRCode.vendaId)}></QrCodeBeaktPix>
      }

    </div>
  );
}